'use strict';

angular.module('clientDashboardApp').filter('pascalCase', function () {
    return function (text) {
        //Undefined phone number
        if (!text) {
            return '';
        }

        //Convert string to "Pascal Format"
        var formattedText =  text.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});

        return formattedText;
    };
});
